// Site Data - Non-translatable data (images, URLs, pricing, dates)
// Translatable text is in translations.js

// Aston Villa Program Images and Static Data
export const astonVillaData = {
  logo: "https://customer-assets.emergentagent.com/job_proficiency-camp/artifacts/n19cmlo6_LOGO-Aston-Villa-Foundation-cuadrado.png",
  images: [
    "https://customer-assets.emergentagent.com/job_proficiency-camp/artifacts/sy0hk5uk_AVFC_SHELFIELD_TRAINING_SEPT_24-6.jpg",
    "https://customer-assets.emergentagent.com/job_proficiency-camp/artifacts/4gzkidc3_AVF_3411.jpg",
    "https://customer-assets.emergentagent.com/job_proficiency-camp/artifacts/6sb9h3td_AVF_3265.jpg",
    "https://customer-assets.emergentagent.com/job_proficiency-camp/artifacts/q5aa869t_AVF_5807fff.png"
  ],
  ageRange: "10-17",
  training: {
    hoursPerWeek: "20+",
    workshops: {
      hours: "8",
      topics: [
        "Sport Psychology",
        "Nutrition for Athletes",
        "Video Analysis",
        "Physical Conditioning",
        "Team Tactics"
      ],
      ledBy: "Aston Villa Foundation coaching staff"
    }
  },
  englishProgram: {
    hoursPerWeek: "7.5 hours",
    groupSize: "Max 15 students",
    levels: "A1 to C1",
    methodology: "Interactive classes focused on football vocabulary and real-world communication.",
    objective: "Build confidence in speaking English through football-themed activities and discussions."
  }
};

// Oakham School Static Data (non-translatable)
export const oakhamSchoolData = {
  location: {
    town: "Oakham",
    region: "Rutland, England",
    fromLondon: "2 hours north of London",
    nearestAirports: ["East Midlands Airport (45 min)", "Birmingham Airport (1 hour)"]
  },
  accommodation: {
    roomTypes: "Shared rooms (double or triple), limited single rooms available",
    bathrooms: "Shared facilities on each floor",
    amenities: [
      "24/7 supervision and security",
      "Daily room cleaning service",
      "Linen and towel changes",
      "Free WiFi throughout",
      "Common areas with TV and games",
      "Laundry service available"
    ]
  },
  dining: {
    meals: "Three nutritious meals per day plus snacks",
    cuisine: "International menu with British classics",
    dietary: "All dietary requirements accommodated",
    features: [
      "Professional catering team",
      "Fresh, locally-sourced ingredients",
      "Balanced athlete nutrition",
      "Vegetarian and vegan options",
      "Allergen-free meals available",
      "Dining hall with stunning architecture"
    ]
  },
  facilities: {
    sports: [
      "Multiple natural grass pitches",
      "Full-size artificial turf pitch",
      "Olympic-size swimming pool",
      "Fully equipped gymnasium",
      "Indoor sports hall",
      "Changing rooms and showers"
    ],
    academic: [
      "Modern classrooms for English lessons",
      "Language labs",
      "Library and study areas",
      "Video analysis room"
    ],
    recreational: [
      "Games room with pool and ping-pong",
      "TV lounges",
      "PlayStation gaming areas",
      "Outdoor recreation spaces"
    ]
  }
};

// Pricing Data
export const pricingData = {
  clinic: [
    { 
      duration: "1 Week", 
      price: "£1,895",
      features: [
        "20+ hours football training",
        "4.5 hours English daily",
        "Full board accommodation",
        "Stadium excursion"
      ]
    },
    { 
      duration: "2 Weeks", 
      price: "£2,895", 
      popular: true,
      features: [
        "40+ hours football training",
        "4.5 hours English daily",
        "Full board accommodation",
        "2 stadium excursions",
        "End of camp tournament"
      ]
    },
    { 
      duration: "3 Weeks", 
      price: "£4,495",
      features: [
        "60+ hours football training",
        "4.5 hours English daily",
        "Full board accommodation",
        "3 stadium excursions",
        "Performance analysis report"
      ]
    },
    { 
      duration: "4 Weeks", 
      price: "£5,695",
      features: [
        "80+ hours football training",
        "4.5 hours English daily",
        "Full board accommodation",
        "4 stadium excursions",
        "Complete performance analysis",
        "Certificate of completion"
      ]
    }
  ],
  astonVilla: [
    { 
      duration: "1 Week", 
      price: "£1,895",
      features: [
        "Official Aston Villa coaching",
        "20+ hours training",
        "Villa Park stadium visit",
        "Full Aston Villa kit"
      ]
    },
    { 
      duration: "2 Weeks", 
      price: "£2,895", 
      popular: true,
      features: [
        "Official Aston Villa coaching",
        "40+ hours training",
        "Villa Park stadium visit",
        "Full Aston Villa kit",
        "Performance evaluation",
        "Certificate of completion"
      ]
    }
  ]
};

// Start Dates
export const startDates = [
  { date: "June 29, 2026", available: true, spotsLeft: 9, programs: ["clinic"] },
  { date: "July 6, 2026", available: true, spotsLeft: 9, programs: ["clinic"] },
  { date: "July 13, 2026", available: false, spotsLeft: 0, programs: ["clinic"], soldOut: true },
  { date: "July 20, 2026", available: true, spotsLeft: 8, programs: ["aston-villa"], clinicSoldOut: true },
  { date: "July 27, 2026", available: true, spotsLeft: 8, programs: ["aston-villa"] }
];

// Home page hero image
export const homeHeroImage = "https://images.pexels.com/photos/35246937/pexels-photo-35246937.jpeg";

// Stadium/Activity Images
export const activityImages = {
  wembley: "https://customer-assets.emergentagent.com/job_proficiency-camp/artifacts/oiqzy2ak_Excursion-a-Wembley-2-2048x1356.jpg",
  premierLeague: "https://customer-assets.emergentagent.com/job_proficiency-camp/artifacts/5etcjytd_Generales%20%2862%29.jpg"
};
